(function () {
  'use strict';

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function updateForm(form) {
    if (!form) return;
    var buttonText = form.querySelector('[data-atc-form] .t4s-btn-atc_text');
    var notice = form.querySelector('[data-fossi-preorder-message]');
    if (!buttonText || !notice) return;

    var expected = normalize(notice.getAttribute('data-preorder-label'));
    var actual = normalize(buttonText.textContent);
    notice.hidden = !(expected && actual === expected);
  }

  function initForm(form) {
    if (!form || form.dataset.fossiPreorderBound === 'true') return;
    form.dataset.fossiPreorderBound = 'true';
    updateForm(form);

    var buttonText = form.querySelector('[data-atc-form] .t4s-btn-atc_text');
    if (buttonText && window.MutationObserver) {
      new MutationObserver(function () { updateForm(form); })
        .observe(buttonText, { childList: true, characterData: true, subtree: true });
    }

    form.addEventListener('change', function () {
      window.setTimeout(function () { updateForm(form); }, 0);
      window.setTimeout(function () { updateForm(form); }, 150);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('variant:changed', function () { init(document); });

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) init(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
